import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo1 from "../assets/logo.webp";
import menuIcon from "../assets/menu.webp";

export default function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) setIsServicesOpen(false); // Reset services when closing menu
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServices = (e) => {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      setIsServicesOpen(!isServicesOpen);
    }
  };

  const scrollToSection = (sectionId) => (e) => {
    e.preventDefault();
    closeMenu();
    if (window.location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <header className="site-header">
      <div className={`nav-container header-inner ${isMenuOpen ? "menu-open" : ""}`}>
        {/* Logo */}
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src={logo1} alt="Site Logo" className="site-logo" width="104" height="84" fetchpriority="high" loading="eager" />
        </Link>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle menu">
          <img src={menuIcon} alt="Menu" width="56" height="56" />
        </button>

        {/* Navigation Wrapper for Mobile */}
        <div className={`nav-wrapper ${isMenuOpen ? "open" : ""}`}>
          <nav className="nav">
            <NavLink to="/" end onClick={closeMenu}>
              Home
            </NavLink>
            <NavLink to="/about" onClick={closeMenu}>About Us</NavLink>
            <div className={`nav-item has-dropdown ${isServicesOpen ? "services-expanded" : ""}`}>
              <NavLink 
                to="/service-inpage" 
                className="nav-parent" 
                onClick={(e) => {
                  if (window.innerWidth <= 1024) {
                    toggleServices(e);
                  } else {
                    closeMenu();
                  }
                }}
              >
                Services
                <span className="dropdown-arrow"></span>
              </NavLink>
              <div className={`dropdown-menu ${isServicesOpen ? "show" : ""}`}>
                <Link to="/corporate-training" className="dropdown-link" onClick={closeMenu}>
                  Corporate Training
                </Link>
                <Link to="/recruitment" className="dropdown-link" onClick={closeMenu}>
                  Recruitment
                </Link>
                <Link to="/software-development" className="dropdown-link" onClick={closeMenu}>
                  Software Development
                </Link>
                <Link to="/business-consulting" className="dropdown-link" onClick={closeMenu}>
                  Business Consulting
                </Link>
              </div>
            </div>
            <NavLink to="/collaboration" onClick={closeMenu}>Collaboration</NavLink>
            <NavLink to="/blogs-new" onClick={closeMenu}>Blogs</NavLink>
            <NavLink to="/photos" onClick={closeMenu}>Social Hub</NavLink>
            <NavLink to="/contact-new" onClick={closeMenu}>Contact Us</NavLink>
          </nav>

          {/* Right CTA Button */}
          <Link to="/newsletter" className="nav-cta" onClick={closeMenu}>
            TTS Insights <span className="nav-cta-arrow">→</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
